<template>
  <div class="upload-large">
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'
  import WebUploader from 'webuploader'
  import xmail from '@/api/api'
  import md5 from 'js-md5'
  import storeLocal from 'store';
  import SparkMD5 from 'spark-md5';
  let accToken = '';
  let fileMd5 = ''
  export default {
    name: 'vue-upload-large',
    props: {
      accept: {
        type: Object,
        default: null,
      },
      // 上传地址
      url: {
        type: String,
        default: '/xmail/ms/v1/filetrans/uploadChunk',
      },
      // 上传最大数量 默认为100
      fileNumLimit: {
        type: Number,
        default: 100,
      },
      // 上传时传给后端的参数
      formData: {
        type: Object,
        default: null
      },
      // 生成formData中文件的key
      // keyGenerator: {
      //   type: Function,
      //   default(file) {
      //     const currentTime = new Date().getTime();
      //     const key = `${currentTime}.${file.name}`;
      //     return key;
      //   },
      // },
      multiple: {
        type: Boolean,
        default: true,
      },
      // 上传按钮ID
      uploadButton: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        uploaderLarge: null,
        userInfo: {userId: '', fileName:'', isChunk:0, chunkIndex:''},   // 用户会话信息
        chunkSize: 2048000,             // 分块大小 (单位：字节)(top.Global.Config.limit.chunkUploadSize)
        uniqueFileName: null,                  // 文件唯一标识符
        preFileUrl: null,                      // 文件预览路径
        curChunkState: null,                   // 当前上传分块状态
        realFileName: null,                    // 真实的文件名称
        md5Mark: null,
        urlPref: '',  // 测试线上的url地址
        configSetting: {},
        chunkRetry: 3,
        accTokenMap: {},
        // fileMd5: '',
        // fileMd5Map: {},
        fileSingleSizeLimit: null
      };
    },
    mounted() {
      this.configSetting = storeLocal.get('Pwm-configSetting');
      // 单个附件大小设置
      this.fileSingleSizeLimit = this.configSetting.deliverSetting.largeAttachMax < 3
        ? this.configSetting.deliverSetting.largeAttachMax * 1024 * 1024 * 1024
        : 3 * 1024 * 1024 * 1024;
      this.initWebUpload();
    },
    methods: {
      async requestSync(url, data) {
        return await axios.post(url, data);
      },
      initWebUpload() {
        let self = this;
        WebUploader.Uploader.register({
          name: 'uploadLarge',
          // 'before-send-file': 'beforeSendFile' //整个文件上传前
          "before-send": "beforeSendLarge"
        }, {
          beforeSendLarge: function(block){

          if (this.options.name == 'uploadLarge') {
            let deferred = WebUploader.Deferred();
            let _key = block.file.id + block.file.name + new Date(block.file.lastModifiedDate).valueOf();
              self.uploaderLarge.md5File(block.blob)
                .then(function(val) {
                  // console.log(this.$i18n.t('wm_lang_0f9b40')+'md5 result:', val);
                  console.log(block.file.name + '第五步，分片上传');
                  console.log(block.file.name + 'accToken的值为：'+ accToken);
                  (function (api, enums, pms) {
                    let fpm = pms.FileTransfer.uploadChunkCheckParamBuilder();
                    fpm.md5 = val;
                    const token = JSON.parse(`{${accToken}}`);
                    fpm.token = token[_key];
                    fpm.chunkIndex = block.chunk;
                    fpm.chunkSize = self.chunkSize;
                    api.FileTransfer.uploadChunkCheck(fpm, function (res) {
                      self.curChunkState = res.status;
                      if(res.data.code === 0) {
                        deferred.reject();
                      } else {
                        deferred.resolve();
                      }
                    })
                  })(xmail.api, xmail.enums, xmail.pms);
                });
              return deferred.promise();
            }
          }
        });
        let urlParams = storeLocal.get('Pwm-urlParams');
        this.uploaderLarge = WebUploader.create({
          name: 'uploadLarge',
          // server: this.getServer("fileUpload"),
          resize: false,  // 尺寸不改变
          compress: false,  // 不启用压缩
          // formData: function(){return $.extend(true, {}, userInfo);},
          auto: false, // 选完文件后，是否自动上传
          swf: '/static/lib/webuploader/Uploader.swf',  // swf文件路径
          server: this.url + urlParams,  // 文件接收服务端
          pick: {
            id: this.uploadButton,     // 选择文件的按钮
            multiple: this.multiple,   // 是否多文件上传 默认false
            label: '',
          },
          // dnd: '#dropUploadWrap',
          disableGlobalDnd: true,
          accept: this.getAccept(this.accept),  // 允许选择文件格式。
          threads: 3,
          fileNumLimit: this.fileNumLimit, // 限制上传个数
          fileSingleSizeLimit: this.fileSingleSizeLimit, // 限制单个上传图片的大小
          formData: this.formData,  // 上传所需参数
          chunked: true,          //分片上传
          chunkSize: this.chunkSize,    //分片大小
          chunkRetry: 3,
          duplicate: true,  // 重复上传
        });

        // 分片上传之前的callback，大文件需多次执行
        this.uploaderLarge.on('uploadBeforeSend', (block, data) => {
          let _key = block.file.id + block.file.name + new Date(block.file.lastModifiedDate).valueOf();
          self.userInfo.chunkIndex = block.chunk;
          // 添加token
          const token = JSON.parse(`{${accToken}}`);
          data.token = token[_key];
          const md5 = JSON.parse(`{${fileMd5}}`);
          data.md5 = md5[_key]
          data.chunkSize = self.chunkSize;
        });

        // 当有文件被添加进队列的时候，添加到页面预览
        this.uploaderLarge.on('fileQueued', (file) => {
          this.$emit('fileChange', file);
        });

        // 每个文件添加到队列之前执行一次
        this.uploaderLarge.on('beforeFileQueued', (file) => {
          console.log('beforeFileQueued')
          let _key = file.id + file.name + new Date(file.lastModifiedDate).valueOf();

          if(file.size > this.$store.getters.largeAttachFreeSize) {
            this.$message({
              type: 'warning',
              message: this.$i18n.t('wm_lang_46ad5e')
            });
            return false;
          }

          if(file.size <= 0) {
            this.$message({
              type: 'warning',
              message: this.$i18n.t('wm_lang_9c710b')+'0kb'+this.$i18n.t('wm_lang_96ce79')
            });
            return false;
          }

          const startTime = new Date().valueOf();
          new Promise(resolve => {
            var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
            chunkSize = 209715200,                             // 每块分为200MB
            chunks = Math.ceil(file.size / chunkSize),
            currentChunk = 0,
            spark = new SparkMD5.ArrayBuffer(),
            fileReader = new FileReader();

            fileReader.onload = function (e) {
                console.log('md5计算的当前分块：', currentChunk + 1, '总分块：', chunks);
                spark.append(e.target.result);
                currentChunk++;

                if (currentChunk < chunks) {
                    loadNext();
                } else {
                    console.log('md5计算完成');
                    const hash = spark.end();
                    console.info('hash: ', hash);
                    const endTime = new Date().valueOf();
                    console.log(`md5计算时长:${(endTime - startTime) / 1000}s`)
                    // self.fileMd5Map[_key] = hash;
                    if (fileMd5.indexOf(_key) == -1) {
                      fileMd5 += fileMd5.length ? `,"${_key}":"${hash}"` : `"${_key}":"${hash}"`;
                    }
                    console.log(file.name + '第一步，计算完成，并对map赋值');
                    resolve();
                }
            };

            fileReader.onerror = function () {
                console.error('读取文件失败');
            };

            function loadNext() {
                var start = currentChunk * chunkSize,
                    end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file.source.source, start, end));
            }

            loadNext();
          })
          .then(function() {
            const md5 = JSON.parse(`{${fileMd5}}`);
            let pm = {fileName: file.name, size: file.size, md5: md5[_key]};

            (function (api, enums, pms) {
              console.log(file.name + '第二步，获取token');
              // 获取文件上传所需的token
              api.LargeFile.uploadFileStartUp(pm, function (res) {
                if(res.data.code === 0){
                  if(res.data.data.existed){
                    let opt = {existed: true, fileId: res.data.data.fileId};
                    self.$emit('success', file, {}, opt);
                    return;
                  }
                  if (accToken.indexOf(_key) == -1) {
                    accToken += accToken.length ? `,"${_key}":"${res.data.data.accToken}"` : `"${_key}":"${res.data.data.accToken}"`;
                  }
                  console.log(file.name + '第三步，赋值token map');
                  console.log(file.name + 'accToken的值为：' + accToken);
                  // 开始上传
                  // if (accToken[_key]) {
                  console.log(file.name + '第四步，开始上传');
                  self.uploaderLarge.upload(file);
                  // }
                  // 解决丢包问题
                  // else {
                  //   console.log(file.name + this.$i18n.t('wm_lang_0ad062')+'1'+this.$i18n.t('wm_lang_e747e8'));
                  //   let timer = setInterval(() => {
                  //     if (accToken[_key]) {
                  //       self.uploaderLarge.upload(file);
                  //       clearInterval(timer);
                  //       timer = null;
                  //     }
                  //   }, 1000);
                  // }
                }
              });
            })(xmail.api, xmail.enums, xmail.pms);
          });
        });

        // 上传成功
        this.uploaderLarge.on('uploadSuccess', (file, response) => {
          let _key = file.id + file.name + new Date(file.lastModifiedDate).valueOf();
          const token = JSON.parse(`{${accToken}}`);
          const md5 = JSON.parse(`{${fileMd5}}`);
          let opt = {token: token[_key], md5: md5[_key]};
          this.$emit('success', file, response, opt);
        });

        this.uploaderLarge.on('uploadStart', (file) => {
          // console.log(file)
          let lastModifiedDate = self.$moment(new Date(file.lastModifiedDate)).format('YYYY-MM-DD HH:mm:ss');
          self.realFileName = file.name;
          let _key = ''+ self.$store.getters.user + self.realFileName + lastModifiedDate + file.size;
          self.uniqueFileName = md5(_key);
          self.userInfo.fileName = self.uniqueFileName;
          self.userInfo.isChunk = Math.ceil(file.size/self.chunkSize) > 1 ? 1 : 0;
          return false;
        });
        // 文件上传过程中创建进度条实时显示。
        this.uploaderLarge.on('uploadProgress', (file, percentage) => {
          this.$emit('progress', file, percentage);
        });
        this.uploaderLarge.on('uploadError', (file, reason) => {
          console.error('reason' + reason);
          this.$emit('uploadError', file, reason);
        });
        this.uploaderLarge.on('error', (type) => {
          let errorMessage = '';
          if (type === 'F_EXCEED_SIZE') {
            errorMessage = `文件大小不能超过${this.fileSingleSizeLimit / (1024 * 1024 * 1024)}G`;
            this.$message({
              type: 'info',
              message: errorMessage
            });
          } else if (type === 'Q_EXCEED_NUM_LIMIT') {
            errorMessage = this.$i18n.t('wm_lang_952f2d');
          } else {
            errorMessage = `上传出错！请检查后重新上传！错误代码${type}`;
          }
          this.$emit('error', errorMessage);
        });
        this.uploaderLarge.on('uploadComplete', (file, response) => {
          this.$emit('complete', file, response);
        });
      },
      upload(file) {
        this.uploaderLarge.upload(file);
      },
      stop(file) {
        this.uploaderLarge.stop(file);
      },
      // 取消并中断文件上传
      cancelFile(file) {
        this.uploaderLarge.cancelFile(file);
      },
      // 在队列中移除文件
      removeFile(file, bool) {
        this.uploaderLarge.removeFile(file, bool);
      },
      // dateFormat(date, fmt) {
      //   let o = {
      //     "M+": date.getMonth() + 1, //月份
      //     "d+": date.getDate(), //日
      //     "h+": date.getHours(), //小时
      //     "m+": date.getMinutes(), //分
      //     "s+": date.getSeconds(), //秒
      //     "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      //     "S": date.getMilliseconds() //毫秒
      //   };
      //   if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      //   for (let k in o)
      //     if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      //   return fmt;
      // },
      // getServer(type){
      //   switch(type){
      //     case "fileUpload": return urlPref + "&method=chunkUpload";    // 文件上传
      //     // case "md5Check": return urlPref + "wudemo/wu/md5Check.do";        // 文件MD5验证
      //     case "chunkCheck": return urlPref + "&method=chunkCheck";     // 分块验证
      //     case "chunksMerge": return urlPref + "&method=chunksMerge";   // 分块合并
      //   }
      // },
      getAccept(accept) {
        switch (accept) {
          case 'text':
            return {
              title: 'Texts',
              exteensions: 'doc,docx,xls,xlsx,ppt,pptx,pdf,txt',
              mimeTypes: '.doc,docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt'
            };
            break;
          case 'video':
            return {
              title: 'Videos',
              exteensions: 'mp4',
              mimeTypes: '.mp4'
            };
            break;
          case 'image':
            return {
              title: 'Images',
              exteensions: 'gif,jpg,jpeg,bmp,png',
              mimeTypes: '.gif,.jpg,.jpeg,.bmp,.png'
            };
            break;
          default: return accept
        }
      },
    },
    watch: {
      fileSingleSizeLimit(newValue) {
        this.uploaderLarge.options.fileSingleSizeLimit = newValue;
      }
    }
  };
</script>

<style lang="scss">
  .webuploader-container {
    position: relative;
  }
  .webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px,1px,1px,1px);
  }
</style>



// WEBPACK FOOTER //
// src/components/sub/uploadLarge.vue